<template>
    <v-app>
        <div v-if="!$route.path.includes('/login')">
            <v-navigation-drawer v-model="drawer" :clipped="$vuetify.breakpoint.lgAndUp" app>
                <v-list dense>
                    <v-list-item-group color="primary">
                        <v-list-item v-for="(item, i) in adminItems" :key="i" :to="item.link">
                            <v-list-item-action>
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ item.text }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-navigation-drawer>
            <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="#FFF" dark>
                <v-app-bar-nav-icon @click.stop="drawer = !drawer" style="color:#000 !important;" />
                <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
                    <span class="hidden-sm-and-down">
                        <router-link to="/">
                            <img src="https://grupowapps.es/images/png/logo/logo.png" alt="grupowapps">

                        </router-link>
                    </span>
                </v-toolbar-title>
                <v-spacer />
                <v-btn tile outlined class="headButton" v-on:click="signOut">
                    Logout
                    <v-icon right color="#000000">mdi-exit-to-app</v-icon>
                </v-btn>
            </v-app-bar>
            <v-content>
                <v-container class="fill-height" fluid>
                    <RouterView />
                </v-container>
            </v-content>
        </div>
        <RouterView v-else />
    </v-app>
</template>

<script>

export default {
    name: 'App',
    data: () => ({
        drawer: null,
        logged: false,
        items: [],
        adminItems: [
            { icon: 'mdi-home', text: 'Home', link: '/' },
            { icon: 'mdi-file-document-check-outline', text: 'Facturas', link: '/invoices' },
            { icon: 'mdi-file-excel', text: 'Presupuestos', link: '/budgets' },
            { icon: 'mdi-account-multiple-outline', text: 'Clientes', link: '/clients' },
            { icon: 'mdi-chart-line', text: 'Contabilidad', link: '/contable' },
        ],
    }),
    mounted() {
        this.checkSession()
    },
    methods: {
        checkSession() {
            this.logged = localStorage.token != null;
            if (!this.logged) this.$router.push('/login');
        },
        signOut() {
            localStorage.clear();
            this.$router.push('/login');
            location.reload();
        }
    }
};
</script>
